import { render, staticRenderFns } from "./marketreport.vue?vue&type=template&id=0fa5c908&scoped=true&"
import script from "./marketreport.vue?vue&type=script&lang=js&"
export * from "./marketreport.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./marketreport.vue?vue&type=style&index=1&id=0fa5c908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5c908",
  null
  
)

export default component.exports